var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    transform: "translate(-69.543 -4.363)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c5c5c5",
    d: "M102.664,43.491H95.316a.3.3,0,0,1-.326-.277V34.768a.3.3,0,0,1,.326-.277h7.348a.3.3,0,0,1,.326.277v8.446A.3.3,0,0,1,102.664,43.491Z",
    transform: "translate(-25.447 -29.128)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    d: "M102.664,43.491H95.316a.3.3,0,0,1-.326-.277V34.768a.3.3,0,0,1,.326-.277h7.348a.3.3,0,0,1,.326.277v8.446A.3.3,0,0,1,102.664,43.491Z",
    transform: "translate(-24.447 -30.128)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.179 5.724)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 4.728,
    height: 0.394,
    rx: 0.197,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 4.728,
    height: 0.394,
    rx: 0.197,
    transform: "translate(0 1.316)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 4.728,
    height: 0.394,
    rx: 0.197,
    transform: "translate(0 2.633)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 4.728,
    height: 0.394,
    rx: 0.197,
    transform: "translate(0 3.949)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 4.728,
    height: 0.394,
    rx: 0.197,
    transform: "translate(0 5.283)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.25a2ed4fc737d8abadb29e722c650d8b.svg";
export { ForwardRef as ReactComponent };